document.addEventListener('DOMContentLoaded', () => {
  const accordionDetails = document.querySelectorAll('.product .accordion details, .faq-section .accordion details, facet-filters-form details, .main-page-content .accordion details');
  const animationDuration = 300;
  const pixelsPerMs = 0.5;
  let isAnimating = false;

  const closeAccordion = (details) => {
    const content = details.querySelector('.accordion__content');
    if (!content) {
      details.removeAttribute('open');
      return;
    }

    const height = content.scrollHeight;
    if (height === 0) {
      details.removeAttribute('open');
      return;
    }

    const duration = Math.min(height / pixelsPerMs, animationDuration);
    content.style.transition = `height ${duration}ms ease-out`;
    content.style.height = height + 'px';

    void content.offsetHeight;

    content.style.height = '0';

    const completeClose = () => {
      details.removeAttribute('open');
      content.removeEventListener('transitionend', completeClose);
    };

    content.addEventListener('transitionend', completeClose);
  };

  accordionDetails.forEach(details => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content');

    const open = () => {
      if (!content) {
        isAnimating = false;
        return;
      }

      const height = content.scrollHeight;
      if (height === 0) {
        content.style.height = 'auto';
        isAnimating = false;
        return;
      }

      const duration = Math.min(height / pixelsPerMs, animationDuration);

      content.style.transition = `height ${duration}ms ease-out`;
      content.style.height = height + 'px';

      const completeOpen = () => {
        content.style.height = 'auto';
        content.removeEventListener('transitionend', completeOpen);
        isAnimating = false;
      };

      content.addEventListener('transitionend', completeOpen);
    };

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (isAnimating) return;
      isAnimating = true;

      const wrapper = details.closest('.accordion-wrapper, .product__info-container, .main-page-content');
      if (wrapper) {
        const otherAccordions = wrapper.querySelectorAll('details[open]');
        otherAccordions.forEach(otherAccordion => {
          if (otherAccordion !== details) {
            closeAccordion(otherAccordion);
          }
        });
      }

      if (details.hasAttribute('open')) {
        closeAccordion(details);
        isAnimating = false;
      } else {
        details.setAttribute('open', '');
        open();
      }
    });

    if (!details.hasAttribute('open')) {
      if (content) {
        content.style.height = '0';
      }
    }
  });
});